const resources = {
    sponsored: 'Sponsored',
    alt: 'Image de bannière avec contenu sponsorisé',
    featuredProduct: 'Featured Products'
};

module.exports = function getResource(label) {
    return resources[label];
};
